import {
  onFaqChange,
  addFaqSuccess,
  updateFaqsSuccess,
  deleteFaqSuccess
} from '../actions/faqs';

const faqsReducer = (state = null, action) => {
  switch(action.type) {
    case 'TEST_ACTION':
      console.log('Test action reducer!');
      return state;
    case 'ADD_FAQ':
      return [
        ...state,
        action.faq
      ]
    case 'ON_FAQ_CHANGE':
      var key = action.key;
      var value = action.value;
      return [
        ...state.slice(0, action.index),
        {
          ...state[action.index],
          [key]: value
        },
        ...state.slice(action.index + 1)
      ]
    case 'UPDATE_FAQS_SUCCESS':
      return action.faqs.slice();
    case 'DELETE_FAQ':
      return [
        ...state.slice(1, action.index),
        ...state.slice(action.index + 1)
      ]
    default:
      return state;
  }
};

export default faqsReducer
